import React, { ReactNode } from "react";
import { Box } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DateTimePickerProps } from "@mui/x-date-pickers/DateTimePicker";
import { DateTimeValidationError, DateValidationError, PickerChangeHandlerContext } from "@mui/x-date-pickers-pro";

import "dayjs/locale/nl";
import dayjs, { Dayjs } from "dayjs";
dayjs.locale("nl");

export type WcDateTimePickerProps = DateTimePickerProps & {
  controlDisabled?: boolean;
  children?: ReactNode;
  width?: number | string;
  required?: boolean;
  error?: any;
  format?: string;
  textfieldFullWidth?: boolean;
  fullWidth?: boolean;
  helperText?: string; //used in WCDatePickerControllers, applied in slotProps -> textfield -> helperText
  // If RHF might store string/Date, you can extend this type:
  value?: Dayjs | string | Date | null;
};

export const WcDateTimePicker = (props: WcDateTimePickerProps) => {
  const { controlDisabled, width, required, error, format, value, fullWidth, slotProps, sx, onChange, ...rest } = props;

  // Normalize to Dayjs | null for the MUI picker
  const parsedValue: Dayjs | null = value == null ? null : dayjs(value as any);

  const handleChange = (newValue: Dayjs | null, context: PickerChangeHandlerContext<DateTimeValidationError>) => {
    if (onChange) {
      onChange(newValue as any, context as any);
    }
  };
  return (
    <Box width={width ? width : fullWidth ? "100%" : 230} id="WcDateTimePicker">
      <LocalizationProvider adapterLocale={"nl"} dateAdapter={AdapterDayjs}>
        <DateTimePicker
          disabled={controlDisabled}
          format={format ? format : "DD/MM/YYYY HH:mm"}
          value={parsedValue}
          onChange={handleChange}
          sx={[...(Array.isArray(sx) ? sx : [sx])]}
          slotProps={{
            ...slotProps,
          }}
          {...rest}
        />
      </LocalizationProvider>
    </Box>
  );
};

export default WcDateTimePicker;
